<div class="clients">
  <div class="title">
    <h1>Accounting</h1>
    <button mat-button class="add-button" (click)="newTemplate()">
      <div class="add-button-c">
        <mat-icon>add</mat-icon>
        <h3>Add new template</h3>
      </div>
    </button>
  </div>
  <div class="clients-list">
    <cdk-accordion class="example-accordion">
      <cdk-accordion-item
        *ngFor="let item of items; let index = index"
        #accordionItem="cdkAccordionItem"
        class="example-accordion-item"
        role="button"
        tabindex="0"
        [attr.id]="'accordion-header-' + index"
        [attr.aria-expanded]="accordionItem.expanded"
        [attr.aria-controls]="'accordion-body-' + index"
      >
        <div class="example-accordion-item-header">
          {{ item }}
          <span class="example-accordion-item-description">
            <button
              mat-button
              [matMenuTriggerFor]="menu"
              (click)="stopDefault($event)"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu" class="matMenu">
              <button mat-menu-item (click)="editTemplate(id)">
                <h3>Edit</h3>
              </button>
              <button mat-menu-item (click)="deleteTempalte(item)">
                <h3>Delete</h3>
              </button>
            </mat-menu>
          </span>
        </div>
        <div
          class="example-accordion-item-body"
          role="region"
          [style.display]="accordionItem.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + index"
          [attr.aria-labelledby]="'accordion-header-' + index"
        >
          <div class="client-box">
            <h3>Total scans</h3>
            <h1>2415</h1>
          </div>
          <div class="client-box">
            <h3>Last 30 days</h3>
            <h1>415</h1>
          </div>
          <div class="client-box">
            <h3>Total income</h3>
            <h1>$1415</h1>
          </div>
          <div class="client-box">
            <h3>Last 30 days</h3>
            <h1>$815</h1>
          </div>
        </div>
      </cdk-accordion-item>
    </cdk-accordion>
  </div>
</div>
